const isValidUrl = urlString => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}

const findHeaderByPath = (headers, path) => {
  const pathParts = path?.split(".") //parse the path to extract typename and id
  if (pathParts?.length !== 3) {
    console.log("Invalid path format. Expected format: headers.default.608")
    return {}
  }

  const targetId = parseInt(pathParts.pop()) // extract ID (e.g., 608)
  const typeName = pathParts.join(".") // extract typename (e.g., "headers.default")

  // map Strapi component names to Gatsby and Next.js __typename values
  const typeNameMap = {
    "headers.default": "STRAPI__COMPONENT_HEADERS_DEFAULT",
    "headers.radian": "STRAPI__COMPONENT_HEADERS_RADIAN",
  }

  // iterate over the headers array to find the header with the matching __typename and ID
  let headerIdx = -1
  const header = headers.find((header, idx) => {
    headerIdx = idx
    return (
      (header.__typename === typeNameMap[typeName] ||
        header.__component === typeName) &&
      (header.id === targetId || header.strapi_id === targetId)
    )
  })

  // if header is found, return header and index; otherwise, return an empty object
  return { header, headerIdx } || {}
}

const findFooterByPath = (footers, path) => {
  const pathParts = path?.split(".") //parse the path to extract typename and id

  if (pathParts?.length !== 3) {
    console.log("Invalid path format. Expected format: footers.default.608")
    return {}
  }

  const targetId = parseInt(pathParts.pop()) // extract ID (e.g., 608)
  const typeName = pathParts.join(".") // extract typename (e.g., "footers.default")

  // map Strapi component names to Gatsby and Next.js __typename values
  const typeNameMap = {
    "footers.default": "STRAPI__COMPONENT_FOOTERS_DEFAULT",
    "footers.minimal": "STRAPI__COMPONENT_FOOTERS_MINIMAL",
    "footers.minimal-slide": "STRAPI__COMPONENT_FOOTERS_MINIMAL_SLIDE",
  }

  // iterate over the footers array to find the footer with the matching __typename and ID
  let footerIdx = -1
  const footer = footers.find((footer, idx) => {
    footerIdx = idx
    return (
      (footer.__typename === typeNameMap[typeName] ||
        footer.__component === typeName) &&
      (footer.id === targetId || footer.strapi_id === targetId)
    )
  })

  // if footer is found, return footer and index; otherwise, return an empty object
  return { footer, footerIdx } || {}
}

const normalizeString = str => {
  return str.trim().toLowerCase() // convert to lower case and trim whitespace
}

const findFontWeightAtInterval = ({
  fontWeight,
  positionInterval = 2,
  fontWeightsObject,
}) => {
  const normalizedKeyMap = Object.keys(fontWeightsObject).reduce((acc, key) => {
    acc[normalizeString(key)] = key
    return acc
  }, {}) //create a hash table from normalized to original keys
  console.log({ normalizedKeyMap })
  const sortedFontWeights = Object.entries(fontWeightsObject)
    .sort((a, b) => a[1] - b[1])
    .map(([key]) => normalizeString(key)) //sort the font weight keys by their numeric values

  const normalizedFontWeight = normalizeString(fontWeight)
  const currentFontWeightIndex = sortedFontWeights.indexOf(normalizedFontWeight)

  if (currentFontWeightIndex === -1) {
    return fontWeight //return the original fontWeight if value does not exist on sortedFontWeights
  }

  const nextFontWeight =
    sortedFontWeights[currentFontWeightIndex + positionInterval] ||
    sortedFontWeights[currentFontWeightIndex] //get the font weight two positions away, or return the last one if already at the end

  const originalKey = normalizedKeyMap[nextFontWeight] // get the original key name to find the correct numeric value in fontWeightsObject
  const nextFontWeightValue = fontWeightsObject[originalKey]

  return nextFontWeightValue
}

const getRedirectURL = (url, siteURL) => {
  let redirectUrl

  if (isValidUrl(url)) {
    // URL is an external URL
    redirectUrl = !url.includes("http") ? `http://${url}` : url
  } else {
    //URL is an page slug
    redirectUrl = `${siteURL}${url}`
  }
  return redirectUrl
}

const getSectionFieldName = sec => {
  const postFix = "Section"
  let sectionName

  if (sec.section) {
    sectionName = sec.section
  } else {
    const sectionAtomName = sec.__typename.split("_")
    const startingIndex = sectionAtomName.indexOf("SECTIONS")
    const sectionPrefixArray = sectionAtomName.slice(startingIndex + 1)

    if (sectionPrefixArray.length === 1) {
      sectionName = sectionPrefixArray[0] + postFix
    } else {
      sectionName = sectionPrefixArray.join("") + postFix
    }
  }
  return sectionName
}

const normalizeSections = sections => {
  return sections?.map(section => {
    if (!section.section) {
      // adding section.section field instead of custom name to make it easier to reference that field for all sections
      let updatedSection
      let sectionName = getSectionFieldName(section)
      updatedSection = { ...section, section: section[sectionName] }
      return updatedSection
    }
    return section
  })
}

const normalize = data => {
  const isObject = data =>
    Object.prototype.toString.call(data) === "[object Object]"
  const isArray = data =>
    Object.prototype.toString.call(data) === "[object Array]"

  const flatten = data => {
    if (!data.attributes) return data

    return {
      id: data.id,
      ...data.attributes,
    }
  }

  if (isArray(data)) {
    return data.map(item => normalize(item))
  }

  if (isObject(data)) {
    if (isArray(data.data)) {
      data = [...data.data]
    } else if (isObject(data.data)) {
      data = flatten({ ...data.data })
    } else if (data.data === null) {
      data = null
    } else {
      data = flatten(data)
    }

    for (const key in data) {
      data[key] = normalize(data[key])
    }

    return data
  }

  return data
}

const fixTypeDefName = name => {
  name = name.replace("RelationResponseCollection", "s")
  name = name.replace("EntityResponseCollection", "s")
  name = name.replace("EntityResponse", "")
  name = name.replace("Entity", "")

  return name
}

const fixTypeRefName = typeDef => {
  if (
    typeDef.name != null &&
    typeDef.name.endsWith("EntityResponseCollection")
  ) {
    typeDef.ofType = {
      kind: "NON_NULL",
      name: null,
      ofType: {
        kind: "OBJECT",
        name: typeDef.name.replace("EntityResponseCollection", ""),
        ofType: null,
      },
    }
    typeDef.kind = "LIST"
    typeDef.name = null

    return typeDef
  }

  if (typeDef.ofType != null) {
    typeDef.ofType = fixTypeRefName(typeDef.ofType)
  }

  if (typeDef.name != null) {
    typeDef.name = fixTypeDefName(typeDef.name)
  }

  return typeDef
}

const fixTypeDef = typeDef => {
  const fixedType = {
    ...typeDef,
    name: fixTypeDefName(typeDef.name),
  }

  fixedType.fields = typeDef.fields.map(y => ({
    ...y,
    type: {
      ...fixTypeRefName(y.type),
    },
  }))

  return fixedType
}

const sectionTitleHasText = (sectionTitle, notGatsby) =>
  sectionTitle
    ? Object.keys(sectionTitle).filter(key => {
        if (key === "title" || key === "label") {
          return sectionTitle[key].length > 0
        } else if (key === "descriptionRichText") {
          let hasContent
          if (notGatsby) {
            hasContent = sectionTitle[key]?.content?.blocks?.[0] && true

            return hasContent
              ? sectionTitle[key]?.content?.blocks?.[0]?.text?.length > 0
              : false
          } else {
            hasContent = sectionTitle[key]?.content?.internal?.content && true

            return hasContent
              ? JSON.parse(sectionTitle[key]?.content?.internal?.content)
                  ?.blocks?.[0]?.text?.length > 0
              : false
          }
        }
      }).length > 0
    : false

module.exports = {
  isValidUrl,
  getRedirectURL,
  normalize,
  getSectionFieldName,
  normalizeSections,
  findFontWeightAtInterval,
  sectionTitleHasText,
  findHeaderByPath,
  findFooterByPath,
}
